export default __webpack_public_path__ + "static/media/element_28.21f0f08a.webp";